module.exports = __webpack_public_path__ + "assets/img/5.0_contact_zz@2x.34ed4093.png";